import { useTranslations } from 'next-intl';
import PhoneButton from './PhoneButton';
import MailButton from './MailButton';

export default function ContactColumn() {
  const t = useTranslations('page.contactColumn');

  return (
    <div>
      <h2 className='mb-4 text-xl font-semibold text-brand md:mt-12'>
        {t('title')}
      </h2>
      <div
        className='mb-6'
        dangerouslySetInnerHTML={{
          __html: String(process.env.NEXT_PUBLIC_CONTACT).replaceAll(
            '|',
            '<br>'
          ),
        }}
      />
      <OrgNr />
      <VatNr />
      <KrsNr />
      <NipNr />
      <RegonNr />
      <YtunnusNr />
      <div className='mt-6 flex flex-col gap-2'>
        <PhoneButton />
        <MailButton />
      </div>
    </div>
  );
}

export function OrgNr() {
  const t = useTranslations('page.contactColumn');

  return process.env.NEXT_PUBLIC_ORG_NR ? (
    <div>
      <span className='font-bold text-brand'>Org nr: </span>
      {process.env.NEXT_PUBLIC_ORG_NR}
    </div>
  ) : null;
}

export function VatNr() {
  const t = useTranslations('page.contactColumn');

  return process.env.NEXT_PUBLIC_VAT_NR ? (
    <div>
      <span className='font-bold text-brand'>VAT nr: </span>
      {process.env.NEXT_PUBLIC_VAT_NR}
    </div>
  ) : null;
}

export function NipNr() {
  return process.env.NEXT_PUBLIC_NIP_NR ? (
    <div>
      <span className='font-bold text-brand'>NIP: </span>
      {process.env.NEXT_PUBLIC_NIP_NR}
    </div>
  ) : null;
}

export function RegonNr() {
  return process.env.NEXT_PUBLIC_REGON_NR ? (
    <div>
      <span className='font-bold text-brand'>REGON: </span>
      {process.env.NEXT_PUBLIC_REGON_NR}
    </div>
  ) : null;
}

export function KrsNr() {
  return process.env.NEXT_PUBLIC_KRS_NR ? (
    <div>
      <span className='font-bold text-brand'>KRS: </span>
      {process.env.NEXT_PUBLIC_KRS_NR}
    </div>
  ) : null;
}

export function YtunnusNr() {
  return process.env.NEXT_PUBLIC_YTUNNUS_NR ? (
    <div>
      <span className='font-bold text-brand'>Y-tunnus: </span>
      {process.env.NEXT_PUBLIC_YTUNNUS_NR}
    </div>
  ) : null;
}
